import React from 'react'
import FileCollaborationToolApp from '../../../../../components/projects/file_collaboration_tool_app'

export default ({ editableTitle, title, name, placeholder, onChange, downloadAllowed, file, adobePreviewFileOptions }) => {
  if (editableTitle) {
    return (
      <input
        type="text"
        name="title"
        className="form-control"
        placeholder={placeholder}
        defaultValue={title}
        onChange={onChange}
      />
    )
  }

  if (downloadAllowed && file) {
    return (
      <a className="download-lnk" href={file.downloadUrl || file.href || file.src} target="_blank" rel="noopener noreferrer">
        {name}
      </a>
    )
  }

  if (!downloadAllowed && adobePreviewFileOptions && file) {
    const props = {adobePreviewFileOptions, file}
    return (
      <FileCollaborationToolApp {...props} />
    )
  }

  return name
}
